import { render } from "./RepairConfirm.vue?vue&type=template&id=4c520048&scoped=true"
import script from "./RepairConfirm.vue?vue&type=script&lang=js"
export * from "./RepairConfirm.vue?vue&type=script&lang=js"

import "./RepairConfirm.vue?vue&type=style&index=0&id=4c520048&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c520048"]])

export default __exports__